import PTabs from './PTabs';
import PTabPane from './PTabPane';

export default function tabsInstall(Vue) {
    if (tabsInstall.installed) {
        return;
    }
    Vue.component('PTabs', PTabs);
    Vue.component('PTabPane', PTabPane);
}


// WEBPACK FOOTER //
// ./src/components/p-tabs/index.js